import {
  ButtonPrimaryV2,
  Container,
  OKELink,
  PaddingTop10,
  PaddingTop5,
  SANS_3,
  SANS_3_4,
  SANS_7_8,
  SERIF_8_9,
  UI_BODY_SEMIBOLD_SM_DF,
  UI_BODY_SM_DF,
  UI_TITLE,
} from "oolib";
import React from "react";
import styled from "styled-components";
import { errorStatesConfig } from "./config";
import image404 from "./../../images/errorSvgs/404.svg";
import image403 from "./../../images/errorSvgs/403.svg";
import image500 from "./../../images/errorSvgs/500.svg";
import image400 from "./../../images/errorSvgs/400.svg";
import image401 from "./../../images/errorSvgs/401.svg";
import { useNavigate } from "react-router-dom";
import { isDeviceOnline } from "../../utils/environmentConfig";
import { useGetQueryData } from "@/utils/react-query-hooks/general";

const StyledContainer = styled(Container)`
  padding: ${(props) => (props.layout === "center" ? "2rem 0rem" : "4rem 0")};
  display: ${(props) => props.layout === "center" && "flex"};
  justify-content: ${(props) => props.layout === "center" && "center"};
  text-align: ${(props) => props.layout === "center" && "center"};
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
`;

const imgConfig = {
  image404,
  image403,
  image500,
  image400,
  image401,
};

const ErrorContainer = ({
  layout,
  img,
  imgConfig,
  opacity,
  imgSize,
  title,
  subTitle,
  action,
}) => {
  return (
    <StyledContainer layout={layout}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center", // Center horizontally
          justifyContent: "center", // Center vertically
          height: "100%", // Take the full height of the container
        }}
      >
        {img && (
          <img
            src={imgConfig[img]}
            alt=""
            style={{
              opacity: opacity ? opacity : layout === "center" ? "0.8" : "0.5",
              height: imgSize ? imgSize + "px" : "120px",
            }}
          />
        )}
        {title && (
          <PaddingTop10>
            <UI_TITLE style={{ fontSize: "20px" }}>{title}</UI_TITLE>
          </PaddingTop10>
        )}
        {subTitle && (
          <PaddingTop5>
            <UI_BODY_SEMIBOLD_SM_DF style={{ fontSize: "14px" }}>
              {subTitle}
            </UI_BODY_SEMIBOLD_SM_DF>
          </PaddingTop5>
        )}
        {action && (
          <PaddingTop5>
            <UI_BODY_SM_DF>
              <OKELink to="#" onClick={action?.actionOnClick}>
                {action?.btnText}
              </OKELink>
            </UI_BODY_SM_DF>
          </PaddingTop5>
        )}
      </div>
    </StyledContainer>
  );
};

const ErrorStates = ({ errorResponseObject, enableLinkToHomepage = true }) => {
  const status = isDeviceOnline()
    ? (errorResponseObject.response?.status || 500)
    : 500;

  const userData = useGetQueryData('userData')

  const errMsgs = isDeviceOnline()
    ? errorResponseObject.response?.data?.errors || // this is the correct structure in which we want to send errors from backend
      errorResponseObject.message //but sometimes we are lazy and send a basic new Error('some message') 
      ? [{ msg: errorResponseObject.message }]
      : [{ msg: "Server Error" }]
    : [{ msg: "Try again when you have an internet connection." }];

  const navigate = useNavigate();

  return (
    <div>
      {errMsgs?.map((errMsg, index) => {
        const conf = errorStatesConfig({ msg: errMsg, user: userData?.user });
        const { imgSize, img, title, layout, subTitle } = conf?.[status] || {};

        return (
          <ErrorContainer
            key={index}
            layout={layout}
            imgConfig={imgConfig}
            imgSize={imgSize}
            img={img}
            subTitle={subTitle}
            title={title}
            action={
              enableLinkToHomepage
                ? {
                    btnText: "Go to homepage",
                    actionOnClick: () => navigate("/"),
                  }
                : undefined
            }
          />
        );
      })}
    </div>
  );
};

export default ErrorStates;
